<template>
    <v-menu activator="parent">
        <v-list>
            <div v-for="(action, index) in actions" :key="index">
                <v-list-item v-if="action.title != '-'" @click="action.onclick != undefined ? action.onclick(action) : undefined">
                    <template v-slot:prepend>
                        <tool-icon v-if="action.icon != undefined" :name="action.icon" />
                    </template>
                    <v-list-item-title>
                        {{ action.title }}
                    </v-list-item-title>
                </v-list-item>
                <v-divider v-else></v-divider>
            </div>
        </v-list>
    </v-menu>
</template>

<script>
import ToolIcon from './ToolIcon.vue';

export default {
    components: {
        ToolIcon,
    },
    name: 'DropdownMenu',
    props: {
        actions: Array,
    },
};
</script>

<style scoped>
</style>
